<mat-spinner *ngIf="isLoading" style="margin: 0 auto"></mat-spinner>
<ng-container *ngIf="!isLoading">
  <app-nav [selectedCase]="clientSelectedCase"></app-nav>
  <div style="background-color: #FAFBFB">
    <main role="main" class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-container>
